import React, { useState,useEffect } from 'react';
import './css/eventform.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt } from "react-icons/fa"; 
import { API_URL_BASE } from './config';

const CreateEventForm = ({ onSuccess,  initialData, onFormChange, existingEventId }) => {
	const navigate = useNavigate();
	const [events, setEvents] = useState([]);
	const [loading, setLoading] = useState(true);
	const [token, setToken] = useState('');
	const [message, setMessage] = useState('');
	const [datemessage, setDateMessage] = useState('');
	const [step, setStep] = useState(0); // Step 1: Create Event
	const [eventId, setEventId] = useState(null);
	const [isChecked, setIsChecked] = useState(false);
	const [contactemail, setContactEmail] = useState('');
	const [emailError, setEmailError] = useState('');
	const [mobileError, setMobileError] = useState('');	
	const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
	const validateMobile = (val) => /^(?:06\d{8}|\+316\d{8})$/.test(val);

	
    const [formData, setFormData] = useState(initialData || {
        eventName: '',
		eventDesc: '',
		eventImage: '',
		eventType : 'FREE',
        organizerName: '',
        eventStartDate: '',
        eventEndDate: '',
        address: '',
		contactemail : '',
		contactno : '',
		eventStatus : 'NEW'
    });
	
	// Step 1: Set tokenId from localStorage
	useEffect(() => {
	  const storedToken = localStorage.getItem('token');
	  if (storedToken) {
	    setToken(storedToken);
	  } else {
	    // Optional: redirect to login or show fallback
	    console.warn("No token found in localStorage");
	    setLoading(false);
		navigate("/");
	  }
	}, []);
	

	const handleChange = (e) => {
	  const { name, value, type, checked } = e.target;

	  setFormData((prevFormData) => {
		const updated = {
	    ...prevFormData,
	    [name]: type === 'checkbox' ? checked : value, // for both input and radio, value works the same
		};
		onFormChange?.(updated);
		return updated;
	  });
	};
	
	
	const handleDateChange = (date, field) => {
	  setFormData((prev) => {
		const updated = { ...prev, [field]: date };
		onFormChange?.(updated);
		return updated;
	  });
	  
	  // Validation: End date should not be before start date
	    if (
	      field === 'eventEndDate' &&
	      formData.eventStartDate &&
	      date < formData.eventStartDate
	    ) {
	      setDateMessage("End date/time cannot be earlier than start date/time.");
	    } else if (
	      field === 'eventStartDate' &&
	      formData.eventEndDate &&
	      formData.eventEndDate < date
	    ) {
	      setDateMessage("End date/time cannot be earlier than start date/time.");
	    } else {
	      setDateMessage("");
	    }
		
	};
	
	const handleImageChange = (e) => {
	  const file = e.target.files && e.target.files[0];
	  if (!file) return; // no file selected
	  
	  const reader = new FileReader();
	    reader.onload = (event) => {
	      const img = new Image();
	      img.src = event.target.result;

	      img.onload = () => {
	        const canvas = document.createElement("canvas");
	        const ctx = canvas.getContext("2d");

	        // Scale down if needed
	        const MAX_WIDTH = 800;
	        const scale = Math.min(1, MAX_WIDTH / img.width);
	        canvas.width = img.width * scale;
	        canvas.height = img.height * scale;

	        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

	        let quality = 0.9;
	        let base64String = "";

	        // Try reducing quality until under 50 KB
	        do {
	          base64String = canvas
	            .toDataURL("image/jpeg", quality)
	            .split(",")[1];
	          quality -= 0.05; // reduce step by step
	        } while (base64String.length / 1024 > 50 && quality > 0.1);

	        console.log("Final size:", Math.round(base64String.length / 1024), "KB");

			setFormData((prev) => {
			  const updated = { ...prev, eventImage: base64String };
			  onFormChange?.(updated);
			  return updated;
			});
	      }
	};

	 /* const reader = new FileReader();
	  reader.onloadend = () => {
		console.log(reader.result);
		const base64String = reader.result.split(",")[1]; // remove prefix "data:image/png;base64,"
		
	    setFormData((prev) => ({
	      ...prev,
	      eventImage: base64String, // base64 string of the image , // keep only the base64 part
	    }));
	  };*/
	  reader.readAsDataURL(file);
	};
	

	const handleSubmit = async (e) => {
		console.log(formData);
	    e.preventDefault();
		try {
			
			const isUpdate = !!existingEventId;

			const payload = isUpdate
				? {
					updateevent: {
						token: token,
						event: {
							eventid: existingEventId,
							name: formData.eventName,
							type: formData.eventType,
							description: formData.eventDesc,
							image: formData.eventImage,
							organisername: formData.organizerName,
							startdatetime: formData.eventStartDate instanceof Date
								? formData.eventStartDate.getTime()
								: formData.eventStartDate,
							enddatetime: formData.eventEndDate instanceof Date
								? formData.eventEndDate.getTime()
								: formData.eventEndDate,
							address: formData.address,
							contactemail: formData.contactemail,
							contactno: formData.contactno,
							status: formData.eventStatus,
						}
					}
				}
				: {
					
								createevent : {
									token: token,
									event  : {	
										name: formData.eventName,
										type: formData.eventType,
										description: formData.eventDesc,
										image: formData.eventImage,
										organisername : formData.organizerName,
										startdatetime:formData.eventStartDate.getTime(),
										enddatetime:formData.eventEndDate.getTime(),
										address:formData.address,
										contactemail:formData.contactemail,
										contactno:formData.contactno,
										status:formData.eventStatus
									}}
						};
						
				const response = await fetch(API_URL_BASE + '/ticket.json', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(payload),
				});
				

		// Check if fetch succeeded (status not blocked)
		if (!response.ok) {
		  throw new Error(`Server error: ${response.status}`);
		}

		const result = await response.json();
		console.log(result);
		setMessage(result.message);
		
		if (result && result.message) {
		  // On update, keep the existing eventId; on create, use the returned one
		  const resolvedEventId = isUpdate ? existingEventId : result.message;
		  onSuccess(resolvedEventId, formData.eventType);
 
		} else {
		  throw new Error("Event save failed");
		}
		
		} catch(e){
			setMessage(e.message || " An unexpected error occurred with Saving the  event!!");
		}	    
	};


    return (
	<div>
			<p className="error-text">{message}</p>
			<form onSubmit={handleSubmit} className="event-form">						
			<div className="event-form-container">
			<h2>Setup New Event</h2>

                <label className="event-form">Event Name<span className="required-asterisk">*</span></label>
                <input type="text" name="eventName" value={formData.eventName} onChange={handleChange}  />
				
				<label className="event-form">Event Description</label>
				<input type="text" name="eventDesc" value={formData.eventDesc} onChange={handleChange}  />
				
				<label className="event-form">Event Image<span className="required-asterisk"> (Max size 1MB)</span></label>
				<div style={{ display: "flex",  gap: "15px" }}>
				{/* Optional image preview */}
				{formData.eventImage && (
				  <img
				    src={`data:image/png;base64,${formData.eventImage}`}
				    alt="Event Preview"
				    style={{ margin: "10px", width: "50px", borderRadius: "8px" }}
				  />
				)}
				<input type="file" name="eventImage" accept="image/*" onChange={handleImageChange}  />
				</div>
				
				<label className="event-form">Event Type<span className="required-asterisk">*</span></label>
				<div className="event-type-wrapper">
				  <label >
				    <input
				      type="radio"
				      name="eventType"
					  value="FREE"
				      checked={formData.eventType === "FREE"}
				      onChange={handleChange}
				    />
				    Free Event
				  </label>

				  <label className="checkbox-label">
				    <input
				      type="radio"
				      name="eventType"
					  value="PAID"
				      checked={formData.eventType === "PAID"}
				      onChange={handleChange}
				    />
				    Paid Ticket Event
				  </label>
				  
				  <label className="checkbox-label">
				    <input
				      type="radio"
				      name="eventType"
				      value="PRIVATE"
				      checked={formData.eventType === "PRIVATE"}
				      onChange={handleChange}
				    />
				    Private Event
				  </label>
				</div>

                <label className="event-form">Organizer Name<span className="required-asterisk">*</span></label>
                <input type="text" name="organizerName" value={formData.organizerName} onChange={handleChange}  />			
				
				<label className="event-form">Event Start<span className="required-asterisk">*</span></label>			
				<div className="datepicker-wrapper">
				<DatePicker
					  className="styled-input"
				      selected={formData.eventStartDate}
				      onChange={(date) =>handleDateChange(date, 'eventStartDate')}
				      showTimeSelect
				      dateFormat="yyyy-MM-dd'T'HH:mm"
					  minDate={new Date()}
				    />
					<FaCalendarAlt className="calendar-icon"/>	
				</div>
				
				<label className="event-form">Event End<span className="required-asterisk">*</span></label>	
				<label className="error-text">{datemessage}</label>			
				<div className="datepicker-wrapper">
				<DatePicker
					  className="styled-input"
				      selected={formData.eventEndDate}
				      onChange={(date) =>handleDateChange(date, 'eventEndDate')}
				      showTimeSelect
				      dateFormat="yyyy-MM-dd'T'HH:mm"
					  minDate={new Date()}
				    />
					<FaCalendarAlt className="calendar-icon"/>	
				</div>			
				
				<label className="event-form">Event Address<span className="required-asterisk">*</span></label>
				<input type="text" name="address" value={formData.address} onChange={handleChange} />	
				
				<label className="event-form">Contact Email<span className="required-asterisk">*</span></label>
				<input type="email" name="contactemail" value={formData.contactemail} 
				placeholder="Contact email address for visitors"
				onChange={(e) => {
				    handleChange(e);
				    if (!validateEmail(e.target.value)) {
				      setEmailError("Please enter a valid email address");
				    } else {
				      setEmailError("");
				    }
				  }} />
				{emailError && <p className="error-text">{emailError}</p>}
				
				<label className="event-form">Contact Mobile<span className="required-asterisk">*</span></label>
				<input type="tel" name="contactno" value={formData.contactno} 
				placeholder="Contact mobile number for visitors 06xxxxxxxx"
				onChange={(e) => {
					handleChange(e);
					if (!validateMobile(e.target.value)) {
						setMobileError("Please enter a valid mobile no");
					} else {
						setMobileError("");
					}
					}} />
				{mobileError && <p className="error-text">{mobileError}</p>}
                <button type="submit" className="submit-btn">{existingEventId ? 'Update Event' : 'Create Event'}</button>

			</div>
			</form>
        </div>
    );
}


export default CreateEventForm;
